import animatePageContent from './animatePageContent'
import getQueryDetails from './getQueryDetails'
import getQueryFirstPage from './getQueryFirstPage'
import getQueryOtherPages from './getQueryOtherPages'

export const animatePageContentPromise = animatePageContent
export const getQueryDetailsPromise = getQueryDetails
export const getQueryFirstPagePromise = getQueryFirstPage
export const getQueryOtherPagesPromise = getQueryOtherPages
